import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import AccountService from 'cio/services/account';
import Transition from '@ember/routing/-private/transition';
import AuthService from 'cio/services/auth';

export default class SettingsIndexRoute extends Route {
  @service account!: AccountService;
  @service auth!: AuthService;

  get showAccountSummary() {
    return this.auth.hasPermission('account/view') && !this.account.isPipelinesOnlyPlan;
  }

  async afterModel(model: unknown, transition: Transition) {
    try {
      // Load account usage, so that it can be used in the UI (for example via
      // the account.usage relationship). Only load for admin users, because
      // they're the ones that can see the account summary panel.
      if (this.showAccountSummary) {
        await this.store.queryRecord('account-usage', {});
      }
    } catch {
      // We didn't manage to load account usage. That's okay—the UI will have
      // indicators to tell users that their usage data may be incorrect. We
      // should still render the rest of the app.
    }

    return super.afterModel(model, transition);
  }
}
